// components/Services.js
import React, { useEffect } from 'react';
import '../Styles/Services.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import {
  FaCloud,
  FaCogs,
  FaDrawPolygon,
  FaGoogle,
  FaPalette,
  FaSitemap,
  FaUsers
} from 'react-icons/fa';

const services = [
  { icon: <FaDrawPolygon />, title: 'GraphQL Development', desc: 'Modern API design and integration using GraphQL.' },
  { icon: <FaSitemap />, title: 'Service Orchestration', desc: 'Streamlined service orchestration for scalable systems.' },
  { icon: <FaCloud />, title: 'Cloud Automation', desc: 'Automate deployments and scale effortlessly on the cloud.' },
  { icon: <FaGoogle />, title: 'Google Cloud Platform', desc: 'Expertise in GCP architecture and optimization.' },
  { icon: <FaPalette />, title: 'UI/UX Design', desc: 'Design intuitive interfaces and engaging user experiences.' },
  { icon: <FaCogs />, title: 'Microservices', desc: 'Build and manage robust microservices-based applications.' },
  { icon: <FaUsers />, title: 'Digital Customer Experience', desc: 'Transform customer interactions through digital innovation.' },
];

function Services() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      offset: 100,
      once: true,
    });
  }, []);

  return (
    <section className="services-section" id="services">
      <div className="container">
        <div className="section-header text-center mb-5">
          <h2>Our <span className="highlight">Services</span></h2>
        </div>
        <div className="row">
          {services.map((service, idx) => (
            <div
              className="col-md-6 col-lg-4 mb-4"
              key={idx}
              data-aos="fade-up"
              data-aos-delay={idx * 100}
            >
              <div className="service-card text-center">
                <div className="service-icon mb-3">{service.icon}</div>
                <h5 className="service-title">{service.title}</h5>
                <p className="service-desc">{service.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
